import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// // // LIST ALL Influencers
export const influencersList = (params = '') => Http.get(`/showcase-influencers${serialize(params)}`)

export const influencerCreate = (params = '') => Http.post('/showcase-influencers', params)
export const influencerByID = (params = '') => Http.get(`/showcase-influencers/${params}?include=showcase,submission,company`)
export const influencerUpdate = (params = '') => Http.put(`/showcase-influencers/${params.id}`, params)
export const influencerDestroy = (params = '') => Http.delete(`/showcase-influencers/${params.id}`)
